import {useTheme} from 'contexts/ThemeContext';
import React, {useEffect} from 'react';
import {Text, TextInput, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface CarouselProps {
  activeElement: number;
  elementsCount: number;
}

const Carousel = (props: CarouselProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <View style={styles.container}>
      {Array(props.elementsCount)
        .fill(0)
        .map((item, index) => (
          <View
            key={index.toString()}
            style={
              index == props.activeElement
                ? styles.activeElement
                : styles.usualElement
            }
          />
        ))}
    </View>
  );
};

export default Carousel;
